import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export const FuseIcon = t0 => {
  const $ = _c(6);
  const {
    fuse,
    size: t1
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] !== fuse) {
    t2 = fuse.replace(" ", "_");
    $[0] = fuse;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `https://wiki.play2xko.com/en-us/images/${t2}_fuse.png`;
  const t4 = `${fuse} Fuse`;
  let t5;
  if ($[2] !== size || $[3] !== t3 || $[4] !== t4) {
    t5 = <Image src={t3} width={size} height={size} alt={t4} />;
    $[2] = size;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};